mutation updateOnboardingCompanyImages($input: UpdateOnboardingCompanyImagesInput!) {
  updateCompanyImages: updateOnboardingCompanyImages(input: $input) {
    id
    images {
      logo {
        url
        name
        id
      }
      team {
        url
        name
        id
      }
      office {
        url
        name
        id
      }
      region {
        url
        name
        id
      }
      lpValuationHero {
        url
        name
        id
      }
    }
  }
}
